import styled from "@emotion/styled";
import {
    boxSizes,
    colors,
    fontFamilies,
    fontSizes,
    fontWeights,
    gutterSizes,
    lineHeights,
    zIndexes,
} from "@gumtree/ui-library/src/base/theme";
import { Logo } from "@gumtree/ui-library";

const SEARCH_ICON_DATA_URI =
    "data:image/svg+xml,%3Csvg%20width%3D%2222%22%20height%3D%2222%22%20viewBox%3D%220%200%2022%2022%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M10.2223%2018.6667C14.886%2018.6667%2018.6667%2014.886%2018.6667%2010.2222C18.6667%205.55849%2014.886%201.77778%2010.2223%201.77778C5.55854%201.77778%201.77783%205.55849%201.77783%2010.2222C1.77783%2014.886%205.55854%2018.6667%2010.2223%2018.6667Z%22%20stroke%3D%22black%22%20stroke-width%3D%221.33333%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M19.5556%2019.5556L17.7778%2017.7778%22%20stroke%3D%22black%22%20stroke-width%3D%221.33333%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";
const TYPE_AHEAD_SEARCH_ICON_DATA_URI =
    "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIiB2aWV3Qm94PSIwIDAgMTIgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSJzZWFyY2gtbm9ybWFsIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTUuNzUgMTAuNUM4LjM3MzM1IDEwLjUgMTAuNSA4LjM3MzM1IDEwLjUgNS43NUMxMC41IDMuMTI2NjUgOC4zNzMzNSAxIDUuNzUgMUMzLjEyNjY1IDEgMSAzLjEyNjY1IDEgNS43NUMxIDguMzczMzUgMy4xMjY2NSAxMC41IDUuNzUgMTAuNVoiIHN0cm9rZT0iIzEwMTgyNCIgc3Ryb2tlLXdpZHRoPSIwLjc1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggaWQ9IlZlY3Rvcl8yIiBkPSJNMTEgMTFMMTAgMTAiIHN0cm9rZT0iIzEwMTgyNCIgc3Ryb2tlLXdpZHRoPSIwLjc1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGcgaWQ9IlZlY3Rvcl8zIiBvcGFjaXR5PSIwIj4KPC9nPgo8L2c+Cjwvc3ZnPgo=";
const TYPE_AHEAD_LOCATION_ICON_DATA_URI =
    "data:image/svg+xml;base64,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";
const TYPE_AHEAD_CLOCK_ICON_DATA_URI =
    "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSJ2dWVzYXgvbGluZWFyL2Nsb2NrIj4KPGcgaWQ9IlVuaW9uIj4KPHBhdGggZD0iTTcuNzUzMjUgNC41MDY1MUM4LjAyOTQgNC41MDY1MSA4LjI1MzI1IDQuNzMwMzcgOC4yNTMyNSA1LjAwNjUxVjcuNzM5NThDOC4yNTMyNSA3Ljg0MTk1IDguMjkyNjQgNy45OTA4MiA4LjM3OTU2IDguMTQzMjNDOC40NDQ2NyA4LjI1NzMzIDguNTIxMjQgOC4zNDcyNSA4LjU5MjQ1IDguNDA2OUw4LjY2MTQ2IDguNDU2MzhMOC42NjI3NiA4LjQ1NzAzTDEwLjcyOTIgOS42OTA3NUMxMC45NjYzIDkuODMyMjcgMTEuMDQzOSAxMC4xMzkyIDEwLjkwMjMgMTAuMzc2M0MxMC43NjA4IDEwLjYxMzIgMTAuNDUzOCAxMC42OTA5IDEwLjIxNjggMTAuNTQ5NUw4LjE1MDM5IDkuMzE1NzVDNy44Nzg3NyA5LjE1NDMgNy42NTk4NSA4LjkwMDY1IDcuNTEwNDIgOC42Mzg2N0M3LjM2MDY2IDguMzc2MDggNy4yNTMyNSA4LjA1NzIyIDcuMjUzMjUgNy43Mzk1OFY1LjAwNjUxQzcuMjUzMjUgNC43MzAzNyA3LjQ3NzExIDQuNTA2NTEgNy43NTMyNSA0LjUwNjUxWiIgZmlsbD0iIzEwMTgyNCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTggMC44MzMzMzNDMTEuOTU2MSAwLjgzMzMzMyAxNS4xNjY3IDQuMDQzODYgMTUuMTY2NyA4QzE1LjE2NjcgMTEuOTU2MSAxMS45NTYxIDE1LjE2NjcgOCAxNS4xNjY3QzQuMDQzODYgMTUuMTY2NyAwLjgzMzMzMyAxMS45NTYxIDAuODMzMzMzIDhDMC44MzMzMzMgNC4wNDM4NiA0LjA0Mzg2IDAuODMzMzMzIDggMC44MzMzMzNaTTggMS44MzMzM0M0LjU5NjE0IDEuODMzMzMgMS44MzMzMyA0LjU5NjE0IDEuODMzMzMgOEMxLjgzMzMzIDExLjQwMzkgNC41OTYxNCAxNC4xNjY3IDggMTQuMTY2N0MxMS40MDM5IDE0LjE2NjcgMTQuMTY2NyAxMS40MDM5IDE0LjE2NjcgOEMxNC4xNjY3IDQuNTk2MTQgMTEuNDAzOSAxLjgzMzMzMyA4IDEuODMzMzNaIiBmaWxsPSIjMTAxODI0Ii8+CjwvZz4KPC9nPgo8L3N2Zz4K";
const TYPE_AHEAD_CLEAR_ICON_DATA_URI =
    "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSJ2dWVzYXgvbGluZWFyL2Nyb3NzIj4KPHBhdGggaWQ9IlVuaW9uIiBkPSJNMTEuNjQ2NSAzLjY0NjUyQzExLjg0MTggMy40NTEyNiAxMi4xNTgzIDMuNDUxMjYgMTIuMzUzNiAzLjY0NjUyQzEyLjU0ODggMy44NDE3OSAxMi41NDg4IDQuMTU4MyAxMi4zNTM2IDQuMzUzNTVMOC43MDcwNyA4LjAwMDA0TDEyLjM1MzYgMTEuNjQ2NUMxMi41NDg3IDExLjg0MTggMTIuNTQ4OCAxMi4xNTgzIDEyLjM1MzYgMTIuMzUzNkMxMi4xNTgzIDEyLjU0ODggMTEuODQxOCAxMi41NDg3IDExLjY0NjUgMTIuMzUzNkw4LjAwMDA0IDguNzA3MDdMNC4zNTM1NSAxMi4zNTM2QzQuMTU4MjkgMTIuNTQ4NyAzLjg0MTc0IDEyLjU0ODcgMy42NDY1MiAxMi4zNTM2QzMuNDUxMyAxMi4xNTgzIDMuNDUxMzkgMTEuODQxOCAzLjY0NjUyIDExLjY0NjVMNy4yOTMwMSA4LjAwMDA0TDMuNjQ2NTIgNC4zNTM1NUMzLjQ1MTI2IDQuMTU4MjkgMy40NTEyNiAzLjg0MTc4IDMuNjQ2NTIgMy42NDY1MkMzLjg0MTc4IDMuNDUxMjYgNC4xNTgyOSAzLjQ1MTI2IDQuMzUzNTUgMy42NDY1Mkw4LjAwMDA0IDcuMjkzMDFMMTEuNjQ2NSAzLjY0NjUyWiIgZmlsbD0iIzEwMTgyNCIvPgo8L2c+Cjwvc3ZnPgo=";
const MESSAGES_ICON_DATA_URI =
    "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M17%2020.5H7C4%2020.5%202%2019%202%2015.5V8.5C2%205%204%203.5%207%203.5H17C20%203.5%2022%205%2022%208.5V15.5C22%2019%2020%2020.5%2017%2020.5Z%22%20stroke%3D%22white%22%20stroke-width%3D%221.5%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M17%209L13.87%2011.5C12.84%2012.32%2011.15%2012.32%2010.12%2011.5L7%209%22%20stroke%3D%22white%22%20stroke-width%3D%221.5%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

const MHC_DESKTOP_BG = "#0d475c";
const MHC_DESKTOP_SEARCH_BG = colors.white;
const MHC_DESKTOP_GREEN = "#5ce00b";
const MHC_DESKTOP_BORDER = "#f0f4fa";
const MHC_DESKTOP_NAV_BORDER = "rgba(16, 24, 36, 0.15)";
const MHC_DESKTOP_TEXT_MUTED = "#a0a8b4";
const MHC_DESKTOP_TEXT_DARK = "#3c3241";
const MHC_DESKTOP_DROPDOWN_SHADOW =
    "0 -0.5px 0 #dce3ee, -0.5px 0 0 #dce3ee, 0.5px 0 0 #dce3ee, 0 0.5px 0 rgba(210, 218, 230, 0.88), 0 6px 16px rgba(16, 24, 36, 0.08), 0 9px 28px rgba(16, 24, 36, 0.05), 0 12px 48px rgba(16, 24, 36, 0.03)";
/* Figma 1222:147783 / message hover&选中：#CFD7E2 @ 20% */
const MHC_DESKTOP_ACTION_HOVER_BG = "rgba(207, 215, 226, 0.2)";
const MHC_DESKTOP_INLINE_MEDIA_QUERY = "@media (min-width: 1025px)";

export const NavContainer = styled.nav`
    background-color: ${MHC_DESKTOP_BG};
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0 24px;
    min-height: 80px;
    padding: 0 24px;
    position: relative;
    width: 100%;
    isolation: isolate;
    z-index: ${zIndexes.high};

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        background-color: ${MHC_DESKTOP_BG};
        box-shadow: 0 0 0 100vmax ${MHC_DESKTOP_BG};
        clip-path: inset(0 -100vmax);
        z-index: -1;
    }

    ${MHC_DESKTOP_INLINE_MEDIA_QUERY} {
        flex-wrap: nowrap;
        margin: 0 auto;
        max-width: 1350px;
        padding: 0 8px;

        &::before {
            border-bottom: 1px solid ${MHC_DESKTOP_NAV_BORDER};
        }
    }
`;

export const NavLogo = styled(Logo)`
    display: flex;
    align-items: center;
    flex: 1;
    flex-shrink: 0;
    height: 80px;

    ${MHC_DESKTOP_INLINE_MEDIA_QUERY} {
        flex: 0 0 auto;
    }

    .logo-text {
        display: flex;
    }
`;

export const SearchBarContainer = styled.div`
    background-color: ${MHC_DESKTOP_BG};
    border-bottom: 1px solid ${MHC_DESKTOP_BORDER};
    box-sizing: border-box;
    flex: 1 0 100%;
    margin: 0 -24px;
    min-width: 0;
    order: 3;
    padding: 0 24px 8px;

    ${MHC_DESKTOP_INLINE_MEDIA_QUERY} {
        background-color: transparent;
        border-bottom: 0;
        flex: 1;
        margin: 0;
        order: 0;
        padding: 0;
    }

    .search-bar-container {
        background-color: transparent !important;
        width: 100%;
    }

    .search-bar {
        padding: 0 !important;

        > div {
            display: block !important;
        }

        .inputs-container--fake-search {
            display: none !important;
        }

        .inputs-container--real-search {
            display: flex !important;
            flex-flow: row nowrap !important;
            align-items: center !important;
            padding: 0 0 0 16px !important;
            padding-bottom: 0 !important;
            margin: 0 !important;
            max-width: none !important;
            background-color: ${MHC_DESKTOP_SEARCH_BG} !important;
            border: 0 !important;
            border-radius: 16px !important;
            height: 48px !important;
            box-sizing: border-box !important;
            position: relative;

            .type-ahead-options {
                box-sizing: border-box;
                top: 56px;
                margin-top: 0;
                padding: ${gutterSizes.medium} ${gutterSizes.base};
                background: ${colors.white};
                border: 0;
                border-radius: ${boxSizes.borderRadius16};
                box-shadow: ${MHC_DESKTOP_DROPDOWN_SHADOW};

                .type-ahead-option {
                    min-height: 38px;
                    padding: ${gutterSizes.base} ${gutterSizes.medium};
                    border-radius: ${boxSizes.borderRadius12};

                    & + .type-ahead-option {
                        margin-top: ${gutterSizes.small};
                    }

                    &:last-of-type {
                        padding-bottom: ${gutterSizes.base};
                    }

                    &.type-ahead-option--focused,
                    &:hover {
                        background-color: ${colors.votBorderSubtle};
                    }

                    .text-part-container {
                        min-width: 0;
                        margin-left: 0;
                    }

                    .type-ahead-option-primary-text {
                        color: ${colors.votTextPrimary};
                        font-family: ${fontFamilies.readexPro};
                        font-size: ${fontSizes.small14};
                        font-weight: ${fontWeights.normal};
                        line-height: ${lineHeights.base};
                    }

                    .type-ahead-option-highlight {
                        font-weight: ${fontWeights.lightBold};
                    }

                    .type-ahead-option-secondary-text {
                        color: ${colors.votTextMuted};
                        font-family: ${fontFamilies.readexPro};
                        font-size: ${fontSizes.smaller};
                        font-weight: ${fontWeights.normal};
                        line-height: ${lineHeights.link};
                    }
                }

                .type-ahead-clear-history-header {
                    margin-bottom: ${gutterSizes.medium};
                    padding: 0 ${gutterSizes.medium};
                    font-family: ${fontFamilies.readexPro};
                    font-size: ${fontSizes.medium};
                    line-height: ${lineHeights.base24};

                    > span {
                        color: ${colors.votTextPrimary};
                        font-weight: ${fontWeights.bold};
                    }
                }
            }

            .keyword-search-container {
                flex: 1;
                min-width: 0;
                position: static;

                .input-field {
                    border-radius: 0 !important;
                    background: transparent !important;
                    height: 48px !important;
                    border: none !important;
                    outline: none !important;
                    box-shadow: none !important;
                    position: static;

                    &.is-focused {
                        outline: none !important;
                    }

                    .icon-container {
                        box-sizing: content-box;
                        flex: 0 0 22px;
                        width: 22px;
                        padding-left: 0;
                        padding-right: 16px;

                        .icon {
                            color: transparent;
                            background-image: url("${SEARCH_ICON_DATA_URI}");
                            background-size: 22px 22px;
                            background-repeat: no-repeat;
                            background-position: center;
                            width: 22px;
                            height: 22px;

                            &::before {
                                display: none;
                            }
                        }
                    }

                    .input {
                        font-size: 16px;
                        font-weight: 330;
                        line-height: 24px;
                        color: ${MHC_DESKTOP_TEXT_DARK};

                        &::placeholder {
                            font-size: 16px;
                            font-weight: 330;
                            color: ${MHC_DESKTOP_TEXT_MUTED};
                            opacity: 1;
                        }
                    }

                    .type-ahead-options {
                        right: ${gutterSizes.base};
                        left: ${gutterSizes.base};
                        width: auto;
                        min-width: 0;

                        .type-ahead-option {
                            align-items: flex-start;
                            gap: ${gutterSizes.small};
                            min-height: 56px;

                            > .icon {
                                flex: 0 0 12px;
                                width: 12px;
                                min-width: 12px;
                                max-width: 12px;
                                height: 12px;
                                margin-top: 5px;
                                background-image: url("${TYPE_AHEAD_SEARCH_ICON_DATA_URI}");
                                background-position: center;
                                background-repeat: no-repeat;
                                background-size: 12px 12px;

                                &::before {
                                    display: none;
                                }
                            }
                        }
                    }
                }
            }

            .dividing-line {
                height: 24px !important;
                border-right: 1px solid ${MHC_DESKTOP_BORDER} !important;
                flex-shrink: 0;
            }

            .location-container {
                display: flex !important;
                align-items: center !important;
                flex-grow: 0 !important;
                flex-shrink: 0;
                gap: 8px;
                margin-top: 0 !important;
                max-width: none !important;
                width: auto !important;

                .icon-container {
                    margin-left: 16px;
                    padding-left: 0;
                    padding-right: 0;
                    width: 16px;

                    .icon {
                        width: 16px;
                        height: 16px;
                        font-size: 16px;
                        color: ${MHC_DESKTOP_TEXT_MUTED} !important;
                    }
                }

                .input-field {
                    flex: 0 0 200px;
                    width: 200px;
                    border-radius: 0 !important;
                    background: transparent !important;
                    height: 48px !important;
                    border: none !important;
                    outline: none !important;
                    box-shadow: none !important;
                    position: static;

                    &.is-focused {
                        outline: none !important;
                    }

                    .input {
                        padding: 4px 8px 4px 4px !important;
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 24px;
                        color: ${MHC_DESKTOP_TEXT_DARK};

                        &::placeholder {
                            color: ${MHC_DESKTOP_TEXT_MUTED};
                            opacity: 1;
                        }
                    }

                    .type-ahead-options {
                        right: -14px;
                        left: auto;
                        width: 360px;
                        min-width: 360px;

                        .type-ahead-option {
                            gap: ${gutterSizes.base};

                            > .icon {
                                flex: 0 0 16px;
                                width: 16px;
                                min-width: 16px;
                                max-width: 16px;
                                height: 16px;
                                background-position: center;
                                background-repeat: no-repeat;
                                background-size: 16px 16px;

                                &.icon--beacon {
                                    background-image: url("${TYPE_AHEAD_LOCATION_ICON_DATA_URI}");
                                }

                                &.icon--clock {
                                    background-image: url("${TYPE_AHEAD_CLOCK_ICON_DATA_URI}");
                                }

                                &::before {
                                    display: none;
                                }
                            }

                            .type-ahead-option-primary-text {
                                font-weight: ${fontWeights.lightBold};
                            }

                            .button--transparent {
                                width: 16px;
                                height: 16px;
                                padding: 0;
                                color: ${colors.votTextPrimary};

                                .icon--clear {
                                    width: 16px;
                                    min-width: 16px;
                                    height: 16px;
                                    background-image: url("${TYPE_AHEAD_CLEAR_ICON_DATA_URI}");
                                    background-position: center;
                                    background-repeat: no-repeat;
                                    background-size: 16px 16px;

                                    &::before {
                                        display: none;
                                    }
                                }
                            }
                        }
                    }
                }

                ${MHC_DESKTOP_INLINE_MEDIA_QUERY} {
                    .input-field {
                        flex-basis: auto;
                        width: auto;

                        .input {
                            flex: 0 0 205px;
                            width: 205px;
                        }
                    }
                }

                .search-button {
                    width: auto !important;
                    height: 32px !important;
                    min-width: auto !important;
                    padding: 0 16px !important;
                    border-radius: 10px !important;
                    background-color: ${MHC_DESKTOP_GREEN} !important;
                    border: none !important;
                    margin: 0 8px 0 0 !important;
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 18px;
                    color: #101824;

                    svg {
                        display: none !important;
                    }

                    &::after {
                        content: "Search";
                        font-size: 12px;
                        font-weight: 500;
                        line-height: 18px;
                        color: #101824;
                    }

                    .icon {
                        display: none !important;
                    }
                }
            }
        }
    }
`;

export const RightActions = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 12px;
    height: 80px;
    margin-left: auto;

    && .messages-button,
    && .user-menu > button {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 48px;
        border: 0;
        border-radius: 8px;
        font-size: 10px;
        font-weight: 330;
        line-height: 18px;
        color: ${colors.white};

        .icon {
            width: 24px;
            height: 24px;
            margin: 0;
            font-size: 24px;
            color: ${colors.white};
        }

        &:hover,
        &:focus-visible,
        &:active {
            color: ${colors.white};
            background-color: ${MHC_DESKTOP_ACTION_HOVER_BG};
        }
    }

    && .user-menu > button {
        width: 48px;
        min-width: 48px;
        padding: 0;
    }

    && .messages-button {
        /* Messages 文案更长：左右各 4px，hover 盒随内容加宽 */
        box-sizing: border-box;
        width: auto;
        min-width: 48px;
        padding: 0 4px;

        .icon--envelope {
            color: transparent;
            background-image: url("${MESSAGES_ICON_DATA_URI}");
            background-size: 24px 24px;
            background-repeat: no-repeat;
            background-position: center;

            &::before {
                display: none;
            }
        }
    }

    && .user-menu {
        display: inline-block;
        position: relative;
    }

    && .mhc-desktop-user-menu {
        &.opened {
            background: transparent;

            > button {
                background-color: ${MHC_DESKTOP_ACTION_HOVER_BG};
            }
        }

        > button {
            border-radius: 8px;

            /* Figma 1222:147783 Menu hover：#CFD7E2 @ 20% */
            &:hover,
            &:focus-visible {
                background-color: ${MHC_DESKTOP_ACTION_HOVER_BG};
            }

            &:after {
                display: none;
            }
        }

        .mhc-desktop-user-sub-menu {
            left: 50%;
            min-width: 200px;
            right: auto;
            top: 52px;
            transform: translateX(-50%);
            width: 200px;

            .sub-menu {
                background: ${colors.white};
                border-radius: 16px;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06), 0 -6px 6px rgba(0, 0, 0, 0.03),
                    0 14px 14px rgba(0, 0, 0, 0.08);
                color: ${colors.votTextPrimary};
                list-style: none;
                margin: 0;
                padding: 4px;
            }

            .sub-menu-item {
                border-radius: 20px;

                &:hover {
                    background-color: #f0f4fa;
                }
            }

            .link-button,
            [data-testid="logout-form"] button {
                align-items: center;
                box-sizing: border-box;
                color: ${colors.votTextPrimary};
                font-size: 14px;
                font-weight: 330;
                gap: 12px;
                height: 36px;
                line-height: 22px;
                padding: 6px 12px;
                text-decoration: none;
            }

            .link-button {
                justify-content: flex-start;
                white-space: nowrap;
            }

            .icon,
            svg {
                color: ${colors.votTextPrimary};
                flex: 0 0 16px;
                font-size: 16px;
                height: 16px;
                margin: 0;
                width: 16px;
            }
        }
    }
`;

export const ActionButton = styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background: none;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    color: ${colors.white};
    padding: 0;

    .icon {
        width: 24px;
        height: 24px;
        color: ${colors.white};
    }

    /* Login / Sign up：与 Messages、Menu 同款 hover 填充 */
    &:hover,
    &:focus-visible {
        background-color: ${MHC_DESKTOP_ACTION_HOVER_BG};
    }
`;

export const ActionLabel = styled.span`
    font-size: 10px;
    font-weight: 330;
    line-height: 18px;
    color: ${colors.white};
    white-space: nowrap;
`;

export const ActionIconWrapper = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;

    svg {
        width: 24px;
        height: 24px;
    }
`;

export const PostAdButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 24px;
    height: 48px;
    background: none;
    border: 1px solid ${MHC_DESKTOP_BORDER};
    border-radius: 14px;
    cursor: pointer;
    font-size: 15px;
    font-weight: 600;
    line-height: 22px;
    color: ${colors.white};
    white-space: nowrap;
    gap: 8px;

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }
`;

export const PostAdLink = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 24px;
    height: 48px;
    background: none;
    border: 1px solid ${MHC_DESKTOP_BORDER};
    border-radius: 14px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: ${colors.white};
    white-space: nowrap;
    text-decoration: none;
    gap: 8px;

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
        color: ${colors.white};
    }
`;
